module.exports = {
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  CollectSuccess: 'Collect success',
  StoreSuccess: 'Store success',
  ReturnSuccess: 'Return success',
  Success: 'Success',
  Exp: 'Exp.',
  UnStored: 'Unstored',
  Stored: 'Stored',
  ExpiredReturned: 'Expired returned',
  Returns: 'Returns',
  Returned: 'Returned',
  Arriving: 'Arriving',
  Collected: 'Collected',
  Created: 'Created',
  Cancelled: 'Cancelled',
  Store: 'Store',
  Collect: 'Collect',
  common: {
    Back: 'Back',
    locationName: '',
    Home: 'Home',
    Save: 'Save',
    Confirm: 'Confirm',
    ScanNext: 'Scan next',
    Cancel: 'Cancel',
    ScanBarcode: 'Scan barcode',
    ScanToStore: 'Scan to store',
    ScanToReturn: 'Scan to return',
    monthArr: new Array('Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Spt', 'Oct', 'Nov', 'Dec'),
    weekArr: new Array('Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'),
    dayFormat: '',
    space: ' ',
    loadMore: 'Load more...',
    finishLoading: 'Loading completed',
    noMore: 'No more items'
  },
  login: {
    LoginTitle: 'Access LoggiPonto',
    Login: 'Login',
    Username: 'Username',
    Password: 'Password'
  },
  bottom: {
    line: 'CS Hotline: '
  },
  index: {
    profile: 'My profile',
    locationName: '',
    Arriving: 'Arriving',
    Stored: 'Stored',
    Collected: 'Collected',
    Returns: 'Returns',
    Store: 'Store',
    Collect: 'Collect',
    Courier: 'Return to courier',
    expired: 'Return expired',
    OrderId: 'Order ID, ',
    PhoneNumber: 'phone number'
  },
  profile: {
    TodayLogs: 'Today logs',
    Total: 'Total',
    ThisMonth: 'This month',
    LocationID: 'Location ID',
    LocationName: 'Location name ',
    Address: 'Address',
    ShopContact: 'Shop contact',
    Username: 'Username',
    RegisteredPhoneNumber: 'Registered phone number',
    BusinessHours: 'Business hours',
    Edit: 'Edit',
    Logout: 'Logout'
  },
  editProfile: {
    EditProfile: 'Edit profile',
    LocationID: 'Location ID',
    LocationNameEnglish: 'Location name (English)',
    LocationNameChinese: 'Location name (Chinese)',
    AddressEnglish: 'Address (English)',
    AddressChinese: 'Address (Chinese)',
    Username: 'Username',
    RegisteredPhoneNnumber: 'Registered phone number',
    BusinessHours: 'Business hours',
    ShopContact: 'Shop contact',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    Rest: 'Rest',
    AddMoreHours: 'Add more hours',
    OpenHours: '24 hours',
    ExceptionsOrHolidays: 'Exceptions or holidays',
    AddSpecialHours: 'Add or remove special hours',
    Open: 'Open',
    Close: 'Close',
    SelectSpecialDays: 'Select special days',
    OK: 'OK',
    Cancel: 'Cancel',
  },
  selectCompany: {
    ReturnCourier: 'Return to courier',
    ReturnExpired: 'Return expired'
  },
  editRemark: {},
  expired: {
    Returns: 'Returns',
    Expired: 'Expired'
  },
  barCode: {
    PleaseAim: 'Please aim at the barcode',
    manually: 'Enter barcode manually',
    Loading: 'Loading...',
    mismatch: 'This parcel does not match the PIN code'
  },
  qrCode: {
    PleaseAim: 'Please aim at the QR code'
  },
  enterBarCode: {
    EnterBarcode: 'Enter barcode',
    EnterName: 'Enter customer name',
    EnterID: 'Enter national ID number'
  },
  enterPIN: {
    EnterPIN: 'Enter PIN code',
    ScanApp: 'Scan App QR'
  },
  success: {
    Note: 'Notes (Optional): e.g. Parcel location',
    ScanParcel: 'Scan parcel location',
    EditNote: 'Edit notes',
    CollectSuccess: 'Collect success',
    StoreSuccess: 'Store success',
    ReturnSuccess: 'Return success',
    Success: 'Success'
  },
  details: {
    OrderDetails: 'Order details',
    OrderID: 'Order ID',
    Logistics: 'Logistics',
    Recipient: 'Recipient',
    TimeStored: 'Time stored',
    Notes: 'Notes',
    Edit: 'Edit',
    ScanBarcode: 'Scan barcode',
    ScanToStore: 'Scan to store',
    ScanToReturn: 'Scan to return',
    TimeCollected: 'Time collected',
    EditNotes: 'Edit notes',
    ScanParcel: 'Scan parcel location'
  },
  total: {
    Total: 'Total',
    Completed: 'Completed',
    InProgress: 'In progress'
  },
  todayLogs: {
    TodayLogs: 'Today logs'
  },
  month: {
    TimeStored: 'Time stored',
    TimeCollected: 'Time collected'
  },
  thisMonth: {
    ThisMonth: 'This month'
  },
  searchResult: {
    CannotFind: 'Cannot find the order',
    TimeStored: 'Time stored',
    TimeCollected: 'Time collected',
    TimeReturned: 'Time returned'
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en.js